import React, { useState, useRef } from "react";
import { AccountAccess } from "../components/account-access.component";
import { Footer } from "../components/footer.component";
import Header from "../components/header.component";
import { NewsPageHeader } from "../components/news/news-page-header.component";
import { NewsSearch, NewsSearchRef } from "../components/news/news-search.component";
import "../scss/main.scss";
import { NewsGrid } from "../components/news/news-grid.component";
import { LOCALES } from '../../common/constants';
import { getSchemaMarkup } from "../../common/FunctionUtils";
import SEOMetadataComponent from '../components/seo-metadata.component';
import { useTranslation } from "react-i18next";
const NewsPage: React.FC = () => {
  const [searchResults, setSearchResults] = useState<any>(null);
  const [searchQuery, setSearchQuery] = useState<string>('');
  const [currentSearchPage, setCurrentSearchPage] = useState<number>(1);
  const itemsPerPage = 9;
  const newsSearchRef = useRef<NewsSearchRef>(null);
  const { t, i18n } = useTranslation();

  const currentLanguage = i18n.language;

  const isEnglish = currentLanguage === 'en' || currentLanguage === LOCALES.EN_US;
  const canonicalUrl = isEnglish
    ? `https://www.invozio.com/news?lang=${LOCALES.EN_US}`
    : `https://www.invozio.com/nyheter?lang=${LOCALES.SV_SE}`;


  const schemaMarkup = getSchemaMarkup("nyheter");
  
  const handleSearchResults = (results: any) => {
    setSearchResults(results);
    if (results && results.currentPage) {
      setCurrentSearchPage(results.currentPage);
    } else if (results === null) {
      setCurrentSearchPage(1);
    }
  };

  const handleSearchQuery = (query: string) => {
    setSearchQuery(query);
    if (!query) {
      setCurrentSearchPage(1);
    }
  };

  const handleSearchPageChange = (page: number) => {
    setCurrentSearchPage(page);
    newsSearchRef.current?.searchWithPage(page);
  };

  return (
    <>
      <Header />
      <SEOMetadataComponent
        title={t('INVOZIO_NEWS_TITLE')}
        // description={t('FEATURES_MAIN_DESCRIPTION')}
        canonicalUrl={canonicalUrl}
        noindex={false}
        robots="index, follow"
        schemaMarkup={schemaMarkup}
      />
      <NewsPageHeader />
      <NewsSearch
        ref={newsSearchRef}
        onSearchResults={handleSearchResults}
        onSearchQuery={handleSearchQuery}
        currentPage={currentSearchPage}
        itemsPerPage={itemsPerPage}
      />
      <NewsGrid
        searchResults={searchResults}
        searchQuery={searchQuery}
        onSearchPage={handleSearchPageChange}
      />
      <div className="bg-footer">
        <AccountAccess />
        <Footer />
      </div>
    </>
  );
};

export default NewsPage;